import React, {useMemo, useState} from "react";
import {grey} from "@material-ui/core/colors";
import DataRow from "view/components/DataRow";
import TimelineIcon from "@material-ui/icons/Timeline";
import {IconButton, useTheme} from "@material-ui/core";
import HistoryIcon from "@material-ui/icons/History";
import {useLastTimelineAction} from "hooks/taskTimeline/useLastTimelineAction";
import {useTranslate} from "@tolgee/react";

import {ITaskTimeline, IShow} from "@evennt-tech/api-v2-core";
import LastActivity from "./LastActivity";
import HistoryModal from "./Modal";
import useStyles from "./styles";

type ActivityHistoryProps = {
  taskId: string;
  isInReview?: boolean;
  standId: string;
  dateFormat: string;
  show: IShow;

  lastAction?: ITaskTimeline | null;
};

function ActivityHistory({
  taskId,
  isInReview,
  standId,
  dateFormat,
  show,
  lastAction: bundledLastAction,
}: ActivityHistoryProps) {
  const theme = useTheme();
  const classes = useStyles();
  const {t} = useTranslate();
  const timelineArgs = useMemo(() => {
    return {showId: show.id, standId, taskId} as const;
  }, [show, standId, taskId]);

  // Use the bundled value when provided, else fall back to a standalone query.
  const isBundled = bundledLastAction !== undefined;
  const [fetchedLastAction, isFetchedLoading] = useLastTimelineAction(
    timelineArgs,
    !isBundled
  );
  const lastAction = isBundled ? bundledLastAction : fetchedLastAction;
  const isLastActionLoading = isBundled ? false : isFetchedLoading;
  const [shouldOpenTimeline, setShouldOpenTimeline] = useState(false);

  return (
    <>
      <DataRow
        label={t("common.tasks.history.title")}
        classes={isInReview ? classes : undefined}
        value={
          isLastActionLoading ? null : (
            <LastActivity
              lastAction={lastAction}
              dateFormat={dateFormat}
              standId={standId}
              showId={show.id}
            />
          )
        }
        actionPanel={
          <IconButton
            disabled={!lastAction}
            onClick={() => setShouldOpenTimeline(true)}
          >
            <HistoryIcon htmlColor={theme.palette.tableRowIcon.main} />
          </IconButton>
        }
        icon={<TimelineIcon htmlColor={grey[500]} />}
      />
      {shouldOpenTimeline && (
        <HistoryModal
          show={show}
          taskId={taskId}
          onClose={() => setShouldOpenTimeline(false)}
          standId={standId}
        />
      )}
    </>
  );
}

export default ActivityHistory;
